export enum UserRole {
  SuperAdmin = 1,
  ToolManager = 2,
  Viewer = 3,
  Pending = 4,
  Blocked = 5,
  Admin = 6,
  WorkzoneManager = 7,
  PromptEditor = 8,
}


export const UserRoleString: { [key: number]: string } = {
  [UserRole.SuperAdmin]: 'Super Admin',
  [UserRole.Admin]: 'Admin',
  [UserRole.WorkzoneManager]: 'Workzone Manager',
  [UserRole.ToolManager]: 'Tool Manager',
  [UserRole.Viewer]: 'Viewer',
  [UserRole.Pending]: 'Pending',
  [UserRole.Blocked]: 'Blocked',
  [UserRole.PromptEditor]: 'Prompt Editor',
};
